module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [(_vm.isJingJiang) ? [_c('div', {
    staticClass: "tab tab2",
    class: {
      active: _vm.pageIndex == 1
    },
    on: {
      "click": function($event) {
        return _vm.showPage(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active1')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab tab2",
    class: {
      active: _vm.pageIndex == 3
    },
    on: {
      "click": function($event) {
        return _vm.showPage(3)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active3')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab tab2",
    class: {
      active: _vm.pageIndex == 5
    },
    on: {
      "click": function($event) {
        return _vm.showPage(5)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active5')))])])] : [_c('div', {
    staticClass: "tab",
    class: {
      active: _vm.pageIndex == 1
    },
    on: {
      "click": function($event) {
        return _vm.showPage(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active1')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.pageIndex == 2
    },
    on: {
      "click": function($event) {
        return _vm.showPage(2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active2')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.pageIndex == 3
    },
    on: {
      "click": function($event) {
        return _vm.showPage(3)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active3')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.pageIndex == 4
    },
    on: {
      "click": function($event) {
        return _vm.showPage(4)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active4')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.pageIndex == 5
    },
    on: {
      "click": function($event) {
        return _vm.showPage(5)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_active5')))])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3c1c6385","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/book/book-comp/bookTab.vue
// module id = 1772
// module chunks = 107